import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "dialog-custom__header mb-4 d-flex align-items-center" }
const _hoisted_2 = { class: "dialog-custom__title m-0" }
const _hoisted_3 = { class: "dialog-custom__content form-custom m-0" }
const _hoisted_4 = { style: {"width":"450px","height":"calc(100vh - 730px)"} }
const _hoisted_5 = { class: "p-field" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "p-field-label" }
const _hoisted_8 = {
  for: "email",
  class: "fs-13 label-error"
}
const _hoisted_9 = { class: "dialog-custom__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.isDialogVisible,
    "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => (_ctx.isDialogVisible = $event)),
    onHide: _ctx.doHideDialog,
    modal: true,
    showHeader: false,
    closable: false,
    class: "dialog-custom invite-residents_dialog"
  }, {
    default: _withCtx(() => [
      _createVNode("header", _hoisted_1, [
        _createVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t("AppResourceEP.InviteTheResident")), 1)
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_ElScrollbar, null, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_5, [
                (_ctx.apartment.apartmentId)
                  ? (_openBlock(), _createBlock("span", _hoisted_6, [
                      _createVNode("label", _hoisted_7, _toDisplayString(_ctx.apartmentInputLabel(_ctx.apartment)), 1),
                      _createVNode(_component_InputText, {
                        type: "email",
                        class: ["w-100", { 'input-error': _ctx.invalidEmail }],
                        placeholder: 
                                    _ctx.$t('AppResourceEP.InsertTheEmail')
                                ,
                        modelValue: _ctx.invite.email,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.invite.email = $event)),
                        onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.invalidEmail = false)),
                        onBlur: _ctx.verifyEmail
                      }, null, 8, ["placeholder", "modelValue", "class", "onBlur"]),
                      _createVNode("label", _hoisted_8, _toDisplayString(_ctx.errorLabel), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode("footer", _hoisted_9, [
        _createVNode(_component_Button, {
          class: "p-button-text mr-2",
          onClick: _ctx.handleHideDialog
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("AppResource.Cancel")), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_Button, {
          label: _ctx.$t('AppResourceEP.InviteUpper'),
          onClick: _ctx.handleButtonSubmitAction,
          class: "p-button-rounded p-button-raised p-button--m"
        }, null, 8, ["label", "onClick"])
      ])
    ]),
    _: 1
  }, 8, ["visible", "onHide"]))
}